import { type DateArg, isAfter, isBefore } from "date-fns";
import type { CurrentCycleData } from "~/entities/profile/current-cycle-data";
import { isSameDayOrEarlier, isSameDayOrLater } from "~/util/dates";

export function extractPeriods(cycle: CurrentCycleData, date: DateArg<Date>) {
    if (!cycle.tracked || !cycle.periods?.length) {
        return { prev: null, current: null, future: null, next: null, first: null, last: null };
    }

    return {
        prev:
            cycle.periods.findLast((period) => {
                return period.ended_at && isAfter(date, period.ended_at);
            }) ?? null,
        current:
            cycle.periods.findLast((period) => {
                return (
                    period.started_at &&
                    isSameDayOrLater(date, period.started_at) &&
                    (!period.ended_at || isSameDayOrEarlier(date, period.ended_at))
                );
            }) ?? null,
        future:
            cycle.periods.findLast((period) => {
                return (
                    !period.started_at &&
                    isSameDayOrLater(date, period.start_at) &&
                    isSameDayOrEarlier(date, period.end_at)
                );
            }) ?? null,
        next:
            cycle.periods.find((period) => {
                return isBefore(date, period.start_at) && (!period.started_at || isBefore(date, period.started_at));
            }) ?? null,
        first: cycle.periods[0] ?? null,
        last: cycle.periods[cycle.periods.length] ?? null,
    };
}
